import React from "react";
import { NavLink, Link } from "react-router-dom";

export default function ({ to, name, Icon, exact, onClick, className, style }) {
  return (
    // use NavLink later
    <NavLink
      to={to}
      className= {className + " header-navlink"}
      style={style}
      onClick={onClick || null}
      exact={exact}
    >
      <div className="header-navlink__ai">
        <img
          src="/assets/images/nav-icons/pln.png"
          alt="img"
          className="header-navlink__pln"
        />
        <img
          src="/assets/images/nav-icons/pln-active.png"
          alt="img"
          className="header-navlink__pln-active"
        />
        <Icon className="header-navlink__icon" />
      </div>
      {name && <p className="header-navlink__name">{name}</p>}
    </NavLink>
  );
}
